import React from 'react'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import LeadDashboardListUI from '../../../components/superUser/account/LeadDashboardListUI.js'
import LeadDashboardCreateModalSF from '../../../components/superUser/account/LeadDashboardCreateModalSF.js'
import LeadDashboardUpdateModalSF from '../../../components/superUser/account/LeadDashboardUpdateModalSF.js'
import SendLeadDashboardEmailModalSF from '../../../components/superUser/account/SendLeadDashboardEmailModalSF.js'

const LeadDashboardPageUI = ({ context, errorList, leadDashboardList, accountList,
  originatorList, salesChannelList, onRefreshClick,
  selectedEntry, createEntryMode, onCreateEntryClick, onCreateEntryCancel,
  updateEntryMode, onUpdateEntryClick, onCancelUpdateEntry,
  sendEmailMode, onSendEmailClick, onCancelSendEmail, emailTemplateList
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_ld_dash' topnav='leadDashboard'
    centered={!leadDashboardList && !errorList} page='leadDashboard'
    dimension='w1600'
  >
    {
      !leadDashboardList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      leadDashboardList &&
      <LeadDashboardListUI context={context}
        leadDashboardList={leadDashboardList}
        accountList={accountList}
        originatorList={originatorList}
        salesChannelList={salesChannelList}
        onRefreshClick={onRefreshClick}
        onCreateEntryClick={onCreateEntryClick}
        onUpdateEntryClick={onUpdateEntryClick}
        onSendEmailClick={onSendEmailClick}
      />
    }

    <LeadDashboardCreateModalSF
      context={context} createEntryMode={createEntryMode} onCreateEntryCancel={onCreateEntryCancel}
      onRefreshClick={onRefreshClick} originatorList={originatorList} salesChannelList={salesChannelList}
    />

    <LeadDashboardUpdateModalSF
      context={context} updateEntryMode={updateEntryMode} onCancelUpdateEntry={onCancelUpdateEntry}
      onRefreshClick={onRefreshClick} entry={selectedEntry}
      originatorList={originatorList} salesChannelList={salesChannelList}
    />

    <SendLeadDashboardEmailModalSF
      context={context} sendEmailMode={sendEmailMode} onCancelSendEmail={onCancelSendEmail}
      onRefreshClick={onRefreshClick}
      entry={selectedEntry} emailTemplateList={emailTemplateList} originatorList={originatorList}
    />

  </SuperUserHomePageUI>

export default LeadDashboardPageUI